import React, { useEffect, useState } from 'react'
import { Row, Col, Avatar, Form, QRCode } from "antd";
import { CameraOutlined } from '@ant-design/icons';
import { Button, TextField } from '..';
import { FaArrowLeftLong } from "react-icons/fa6";
import LabelWithField from '../LabelWithField';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { AddCheckPoints, UserSignin } from '../../config/Schema';
import LabelWithSelect from '../LabelWithSelect';
import { FaPlus } from "react-icons/fa6";
import { Colors } from '../../config';
import CheckBoxField from '../Select/Checkbox';
// import QRCode from "react-qr-code";
import { useQuery } from 'react-query';
import { getAddresses, getIncidents } from '../../config/getApis';
import { UseDispatch, useDispatch, useSelector } from 'react-redux';
import { SiteManagementAction } from '../../store/actions';
import { useParams } from 'react-router-dom';
import useColors from '../../hooks/useColors';

const defaultData = {
    name: "",
    location: "",
    code: "",
    unit: "",
    reportNotes: "",
    officerNotes: "",
    addressId: "",
    propertiesIncidentTypesId: ""
}


const CheckPoint = ({ checkPointEditData, onCloseDrawer, isCheckpointDetail = false, title }) => {
    const { colorPrimary } = useColors()

    const { id } = useParams();

    const { data: incidentOptions } = useQuery('incidentsOpt', getIncidents);

    const { data: addressOptions } = useQuery('addressOpt', getAddresses);

    const schema = AddCheckPoints;
    const { handleSubmit, control, reset, setValue, watch, getValues } = useForm(
        {
            resolver: yupResolver(schema),
            mode: 'onChange'
        }
    )

    // const val = getValues('code');
    const [codeValue, setCodeValue] = useState(checkPointEditData?.code ? checkPointEditData?.code : '')
    // const [qrValue, setQrValue] = useState(checkPointEditData?.code ? checkPointEditData?.code : '');
    const [qrCodeValueObj, setQrCodeValueObj] = useState(null)

    const dispatch = useDispatch()
    const checkPointLoader = useSelector(state => state?.SiteManagementReducer?.loader);

    useEffect(() => {
        reset({
            name: checkPointEditData?.name,
            location: checkPointEditData?.location,
            code: checkPointEditData?.code,
            unit: checkPointEditData?.unit,
            reportNotes: checkPointEditData?.reportNotes,
            officerNotes: checkPointEditData?.officerNotes,
            addressId: checkPointEditData?.address?.id,
            propertiesIncidentTypesId: checkPointEditData?.incidentType?.id
        })
        if (title == 'Edit') {
            setQrCodeValueObj({
                checkPointId: checkPointEditData?.id,
                propertyId: id || localStorage.getItem('PropertyKey')
            })
        }
    }, [checkPointEditData])

    const codeHandler = (e) => {
        let query = e?.target.value;
        setCodeValue(query)
        // setting qr value
        // setQrValue(query)
    }

    const handleSubmitHandler = (data) => {
        console.log(data)
        data.code = codeValue;
        if (title == 'Add') {
            dispatch(SiteManagementAction.AddCheckpoint(data, id, () => {
                let checkPointId = localStorage.getItem('checkpointId');
                localStorage.setItem('isCheckpointUpdated', true)
                setQrCodeValueObj({
                    checkPointId,
                    propertyId: id
                })
                reset(defaultData)
                setCodeValue('')
            }))
        }
        else {
            dispatch(SiteManagementAction.EditCheckpoint(data, checkPointEditData?.id, (payload) => {
                localStorage.setItem('isCheckpointUpdated', true)
                if (!isCheckpointDetail) {
                    dispatch(SiteManagementAction.GetCheckPoints(payload))
                }
                onCloseDrawer()
            }))
        }

    };

    const printHandler = async () => {
        // First, generate the QR code as a data URL using the existing QR code on the page
        const qrCanvas = document.querySelector('canvas'); // Get the existing QR code canvas
        let qrDataUrl;

        if (qrCanvas) {
            // If you have the QR code already rendered, use it
            qrDataUrl = qrCanvas.toDataURL('image/png');
        } else {
            // Otherwise, create a temporary canvas to generate it
            const tempCanvas = document.createElement('canvas');
            const QRCode = (await import('https://cdn.skypack.dev/qrcode')).default;
            await QRCode.toCanvas(tempCanvas, JSON.stringify(qrCodeValueObj), {
                width: 200,
                margin: 2
            });
            qrDataUrl = tempCanvas.toDataURL('image/png');
        }

        // Open print window
        const printWindow = window.open("", "_blank");
        if (!printWindow) return;

        const qrGridHTML = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print QR Codes</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
          }
          .qr-box {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            page-break-inside: avoid;
            padding: 10px;
          }
          .qr-image {
            width: 150px;
            height: 150px;
            border: 1px solid #ddd;
            padding: 5px;
            background: white;
          }
          .qr-label {
            margin-top: 10px;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
          }
          @media print {
            body {
              padding: 15px;
            }
          }
        </style>
      </head>
      <body>
        ${Array.from({ length: 12 })
                .map(
                    (_, i) => `
          <div class="qr-box">
            <img src="${qrDataUrl}" alt="QR Code ${i + 1}" class="qr-image" />
            <div class="qr-label">QR #${i + 1}</div>
          </div>`
                )
                .join("")}
        
        <script>
          window.onload = function() {
            setTimeout(() => {
              window.print();
            }, 500);
          };
        </script>
      </body>
    </html>
  `;

        printWindow.document.open();
        printWindow.document.write(qrGridHTML);
        printWindow.document.close();

    };



    return (
        <Row className='px-2'>
            <form layout="vertical" className='w-full'>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='name'
                            defaultValue={''}
                            render={({ field, fieldState }) => (
                                <>
                                    <LabelWithField
                                        labeltext={'Checkpoint Name'}
                                        field={field}
                                        labelClass={'font-normal'}
                                        inputClass={'h-10 rounded outline-none'} />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>
                            )}
                        />
                    </Col>
                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='location'
                            defaultValue={''}
                            render={({ field, fieldState }) => (
                                <>
                                    <LabelWithField
                                        labeltext={'Checkpoint Location'}
                                        field={field}
                                        labelClass={'font-normal'}
                                        inputClass={'h-10 rounded outline-none'} />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>
                            )}
                        />
                    </Col>
                </Row>
                <Row gutter={16} className='my-2'>
                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='code'
                            defaultValue={''}
                            render={({ field, fieldState }) => (
                                <>
                                    <div className="flex flex-col py-4 w-full">
                                        <label
                                            className={'font-normal'}
                                            style={{ color: Colors.LabelColor }}
                                        >
                                            NFC Code Value
                                        </label>
                                        <input type={'text'}
                                            value={codeValue}
                                            onChange={codeHandler}
                                            className={`pl-2.5 h-10 rounded outline-none`}
                                            style={{ background: Colors.LightGray }}
                                        />
                                    </div>
                                </>
                            )}
                        />

                    </Col>

                    {/* <Col lg={5} xs={0} sm={0}>
                        <QRCode value={codeValue} size={80} className='ml-6' />
                    </Col> */}

                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='addressId'
                            render={({ field, fieldState }) => (
                                <>
                                    <LabelWithSelect
                                        options={addressOptions}
                                        labeltext={'Property Address'}
                                        field={field}
                                        labelClass={'font-normal'}
                                        inputClass={'outline-none h-10 rounded'}
                                    />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>
                            )}
                        />
                    </Col>
                </Row>
                <Row gutter={16} className='mb-2'>
                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='unit'
                            render={({ field, fieldState }) => (
                                <>
                                    <LabelWithField
                                        labeltext={'Checkpoint Units'}
                                        field={field}
                                        labelClass={'font-normal'}
                                        inputClass={'h-10 rounded outline-none'} />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>
                                // <>
                                //     <LabelWithSelect
                                //         options={checkPointsUnitOptions}
                                //         labeltext={'Checkpoint Units'}
                                //         field={field}
                                //         labelClass={'font-normal'}
                                //         inputClass={'outline-none h-10 rounded'}
                                //     />

                                //     {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                // </>
                            )}
                        />
                    </Col>

                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='propertiesIncidentTypesId'
                            render={({ field, fieldState }) => (
                                <>
                                    <LabelWithSelect
                                        options={incidentOptions}
                                        labeltext={'Checkpoint Incident Type'}
                                        field={field}
                                        labelClass={'font-normal'}
                                        inputClass={'outline-none h-10 rounded'}
                                    />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>

                            )}
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='reportNotes'
                            render={({ field: { value, onChange }, fieldState }) => (
                                <>
                                    <TextField.Textarea
                                        style={{ color: Colors.LightGray }}
                                        placeholder={''}
                                        value={value}
                                        onChange={onChange}
                                        labeltext={'Report Notes'}
                                        className={'outline-none h-10 rounded'}
                                    />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>
                            )}
                        />
                    </Col>

                    <Col lg={12} xs={24}>
                        <Controller
                            control={control}
                            name='officerNotes'
                            render={({ field: { value, onChange }, fieldState }) => (
                                <>
                                    <TextField.Textarea
                                        style={{ color: Colors.LightGray }}
                                        placeholder={''}
                                        value={value}
                                        onChange={onChange}
                                        labeltext={'Officer Notes'}
                                        className={'outline-none h-10 rounded'}
                                    />
                                    {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                </>
                            )}
                        />
                    </Col>
                </Row>
                <br />
                <Row gutter={16}>
                    <Col span={12} className='invisible'>
                        <CheckBoxField
                            label={'Auto Create Issue Type'}
                        />
                    </Col>
                </Row>
                <Row gutter={16} className='flex justify-between items-start'>
                    <Col lg={12} className='flex items-center gap-5'>
                        {/* showing qr code to scan property and current created checkpoint id */}
                        {
                            qrCodeValueObj &&
                            <>
                                <QRCode size={100} value={JSON.stringify(qrCodeValueObj)} />
                                <Button.Basic
                                    text={'Print QR Code'}
                                    className="h-8 px-6 border-none text-white border-transparent"
                                    style={{ backgroundColor: colorPrimary }}
                                    onClick={printHandler}
                                />
                            </>
                        }
                    </Col>

                    <Col lg={12} className='text-end'>
                        <Button.Basic
                            onClick={handleSubmit(handleSubmitHandler)}
                            htmlType="submit"
                            className="h-12 px-6 border-none text-white border-transparent"
                            style={{ backgroundColor: colorPrimary }}
                            text={"Save"}
                            type={"submit"}
                            loader={checkPointLoader}
                        />
                    </Col>
                </Row>
            </form>

        </Row>
    )
}

export default CheckPoint


var checkPointsUnitOptions = [
    {
        value: 'floor 1',
        label: 'Floor 1',
    },
    {
        value: 'floor 2',
        label: 'Floor 2',
    },
    {
        value: 'floor 3',
        label: 'Floor 3',
    },

]
